<template>
    <!-- main start  -->
    <div id="main">
        <!-- Main Header -->
        <MainHeader />
        
        <!-- Top Header -->
        <div class="top-header top-header-half">
            <div class="page-subtitle">
                <span>{{ page ? page.title : 'Page' }}</span>
            </div>
            <router-link to="/contact" class="single-page-fixed-row-link">
                <i class="fal fa-envelope"></i> <span>Get In Touch</span>
            </router-link>
        </div>
        <!-- top-header end-->
        
        <!-- wrapper  -->	
        <div id="wrapper">
            <!-- content-holder  -->	
            <div class="content-holder" data-pagetitle="Page">
                <!-- Navigation -->
                <Navigation />
                
                <!-- content-->
                <div class="content">
                    <!--fixed-column-wrap-->
                    <div class="fixed-column-wrap init_fx-column fcw_mob-hidden" v-if="page && page.banner_image">
                        <!--fixed-column-wrap-content-->
                        <div class="fixed-column-wrap-content">
                            <div class="fixed-column-wrap_bg">
                                <div class="bg bg-scroll" :data-bg="page.banner_image"></div>
                                <div class="overlay"></div>
                                <div class="column-image-anim"></div>
                                <div class="hero-scroll-down-notifer">
                                    <div class="scroll-down-wrap">
                                        <div class="mousey">
                                            <div class="scroller"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="fixed-column-dec"></div>
                            </div>
                            <!--fixed-column-wrap_title-->
                            <div class="fixed-column-wrap_title">
                                <h2><span>{{ page.title }}</span></h2>
                            </div>
                            <!--fixed-column-wrap_title end-->
                            <div class="scroll-notifer">Scroll Down</div>
                            <div class="fwc-dec fwc-dec_top"></div>
                            <div class="fwc-dec fwc-dec_right"></div>
                            <div class="fixed-column-wrap_dec"></div>
                        </div>
                        <!--fixed-column-wrap-content end-->
                    </div>
                    <!--fixed-column-wrap end-->
                    
                    <!--column-wrap--> 
                    <div class="column-wrap">
                        <!--column-wrap-container -->   
                        <div class="column-wrap-container white-bg fl-wrap">
                            <div class="col-wc_dec"></div>
                            
                            <!-- Loading State -->
                            <section v-if="loading" class="scroll-con-sec">
                                <div class="container">
                                    <div class="section-title fl-wrap">
                                        <h2>Loading...</h2>
                                    </div>
                                </div>
                            </section>
                            
                            <!-- Error State -->
                            <section v-else-if="error" class="scroll-con-sec">
                                <div class="container">
                                    <div class="section-title fl-wrap">
                                        <h2>{{ error }}</h2>
                                        <div class="sec-title_dec"></div>
                                    </div>
                                    <div class="column-wrapper_text fl-wrap">
                                        <p>The page you are looking for could not be found.</p>
                                        <router-link to="/" class="btn float-btn">
                                            <span>Go to Homepage</span>
                                        </router-link>
                                    </div>
                                </div>
                            </section>
                            
                            <!-- Page Content -->
                            <section v-else-if="page" id="sec1" class="scroll-con-sec">
                                <div class="container">
                                    <div class="section-title fl-wrap">
                                        <h2>{{ page.title }}</h2>
                                        <p v-if="page.description">{{ page.description }}</p>
                                        <div class="sec-title_dec"></div>
                                    </div>
                                    
                                    <!-- Main Content with Image -->
                                    <div class="row" v-if="page.featured_image">
                                        <div class="col-md-5">
                                            <div class="about-img fl-wrap">
                                                <img :src="page.featured_image" class="respimg" :alt="page.title">
                                            </div>
                                        </div>
                                        <div class="col-md-7">
                                            <div v-html="page.content"></div>
                                        </div>
                                    </div>
                                    
                                    <!-- Main Content without Image -->
                                    <div v-else v-html="page.content"></div>
                                </div>
                                <div class="section-number">
                                    <span>0</span>1<strong>.</strong>
                                </div>
                            </section>
                            
                            <!-- content_type_group blocks: category cards -->
                            <section
                                class="scroll-con-sec gray-bg"
                                id="sec2"
                                v-for="(item, index) in contentTypeGroupItems"
                                :key="'ctg-section-' + item.id"
                            >
                                <div class="container">
                                    <div class="project-cat-grid">
                                        <router-link
                                            v-for="child in item.content_type_group.children"
                                            :key="child.id"
                                            :to="`/projects/${child.slug}`"
                                            class="project-cat-card"
                                        >
                                            <div class="project-cat-card-media" :style="{ backgroundImage: child.featured_image ? `url(${child.featured_image})` : null }"></div>
                                            <div class="project-cat-card-caption">
                                                <h3>{{ child.name }}</h3>
                                                <p v-if="child.description">{{ child.description }}</p>
                                            </div>
                                        </router-link>
                                    </div>
                                </div>
                                <div class="section-number"><span>0</span>{{ index + 2 }}<strong>.</strong></div>
                            </section>

                            <!-- Page Items Section (matches ServicesSection design) -->
                            <section class="scroll-con-sec gray-bg" id="sec3" v-if="staticPageItems.length">
                                <div class="container">
                                    <div class="column-wrapper_text fl-wrap">
                                        <!-- serv-wrap-->
                                        <div class="serv-wrap fl-wrap">
                                            <div
                                                class="serv-item"
                                                :class="{ 'serv-item-right': index % 2 === 1 }"
                                                v-for="(item, index) in staticPageItems"
                                                :key="item.id"
                                            >
                                                <div class="serv-media">
                                                    <div class="bg" :data-bg="item.image"></div>
                                                    <div class="team-info-num">{{ String(index + 1).padStart(2, '0') }}.</div>
                                                </div>
                                                <div class="serv-text">
                                                    <h3>{{ item.title }}</h3>
                                                    <div v-html="item.content"></div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- serv-wrap end -->
                                    </div>
                                </div>
                                <div class="section-number"><span>0</span>{{ contentTypeGroupItems.length + 2 }}<strong>.</strong></div>
                            </section>
                            <!-- section end-->
                            
                        </div>
                        <!--column-wrap-container end-->  
                    </div>
                    <!--column-wrap end-->					
                    <div class="limit-box fl-wrap"></div>
                </div>
                <!-- content end  -->
                
                <!-- Footer -->
                <div class="height-emulator fl-wrap"></div>
                <AppFooter />
                
            </div>
            <!-- content-holder end -->
        </div>
        <!-- wrapper end -->
    </div>
    <!-- Main end -->
</template>

<script>
import MainHeader from '@/components/MainHeader.vue'
import Navigation from '@/components/Navigation.vue'
import AppFooter from '@/components/Common/AppFooter.vue'

export default {
    name: 'Pages',
    components: {
        MainHeader,
        Navigation,
        AppFooter
    },
    data() {
        return {
            page: null,
            loading: true,
            error: null
        }
    },
    computed: {
        contentTypeGroupItems() {
            if (!this.page || !this.page.page_items) return []
            return this.page.page_items.filter(item => item.block_type === 'content_type_group' && item.content_type_group)
        },
        staticPageItems() {
            if (!this.page || !this.page.page_items) return []
            return this.page.page_items.filter(item => item.block_type !== 'content_type_group')
        }
    },
    async mounted() {
        await this.loadPage()
        // Process backgrounds after page loads
        this.$nextTick(() => {
            setTimeout(() => {
                this.processBackgrounds()
            }, 300)
        })
    },
    watch: {
        async '$route'() {
            await this.loadPage()
            // Process backgrounds when route changes
            this.$nextTick(() => {
                setTimeout(() => {
                    this.processBackgrounds()
                }, 300)
            })
        }
    },
    methods: {
        async loadPage() {
            const slug = this.$route.params.slug
            
            if (!slug) {
                this.error = 'Page not found'
                this.loading = false
                return
            }
            
            this.loading = true
            this.error = null
            
            try {
                const response = await this.$api.get(`public/pages/${slug}`)
                
                if (response.data && response.data.status === 'success') {
                    this.page = response.data.data
                    
                    // Update page meta
                    if (this.page.meta_title) {
                        document.title = this.page.meta_title
                    } else if (this.page.title) {
                        document.title = this.page.title
                    }
                    
                    if (this.page.meta_description) {
                        const metaDescription = document.querySelector('meta[name="description"]')
                        if (metaDescription) {
                            metaDescription.setAttribute('content', this.page.meta_description)
                        }
                    }
                    
                    console.log('✅ Loaded page:', this.page.title)
                } else {
                    this.error = 'Page not found'
                }
            } catch (error) {
                console.error('❌ Failed to load page:', error)
                if (error.response && error.response.status === 404) {
                    this.error = 'Page not found'
                } else {
                    this.error = 'Failed to load page content'
                }
            } finally {
                this.loading = false
            }
        },
        
        processBackgrounds() {
            const $ = window.jQuery
            if (!$) return
            
            // Process all data-bg attributes (banner, page items, etc.)
            $('[data-bg]').each(function() {
                const bg = $(this).attr('data-bg')
                if (bg) {
                    $(this).css('background-image', 'url(' + bg + ')')
                }
            })
            
            // Specifically process page item backgrounds
            $('.serv-media .bg[data-bg]').each(function() {
                const bg = $(this).attr('data-bg')
                if (bg) {
                    $(this).css('background-image', 'url(' + bg + ')')
                }
            })
            
            // Update fixed-column height if present
            if ($(".fixed-column-wrap").length) {
                $(".fixed-column-wrap").css({
                    height: $(window).outerHeight(true)
                })
            }
            
            // Update height-emulator for footer reveal
            if ($(".height-emulator").length && $(".main-footer").length) {
                $(".height-emulator").css({
                    height: $(".main-footer").outerHeight(true)
                })
            }
            
            console.log('✅ Processed page backgrounds and dimensions')
        }
    }
}
</script>
